import { useEffect } from "react";

/**
 * Tiny SEO hook — sets document.title + meta description + OG/Twitter tags
 * per page without adding any extra dependency.
 */
export default function useSEO({
  title,
  description,
  canonical,
  image,
}) {
  useEffect(() => {
    if (title) document.title = title;

    const upsertMeta = (attr, key, value) => {
      if (!value) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    if (image) {
      upsertMeta("property", "og:image", image);
      upsertMeta("name", "twitter:image", image);
    }
    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
      upsertMeta("property", "og:url", canonical);
    }
  }, [title, description, canonical, image]);
}

export const BASE_URL = "https://labomboneradebarcelona.es";
export const DEFAULT_OG_IMAGE = "https://labomboneradebarcelona.es/logo512.png";
